import { FC, useEffect, useState } from 'react';
import { Spin as AntdSpin } from 'antd';
import styled from 'styled-components';

export const SpinV1: FC = () => {
  const [ready, setReady] = useState(false);

  // Fix error Prop `className` did not match. Server:
  useEffect(() => setReady(true), []);

  return ready ? <AntdSpin /> : null;
};

export const SpinV2: FC = () => {
  const [ready, setReady] = useState(false);

  // Fix error Prop `className` did not match. Server:
  useEffect(() => setReady(true), []);

  return ready ? <AntdSpinV2 /> : null;
};

const AntdSpinV2 = styled(AntdSpin)`
  animation-name: spin;
  animation-duration: 3000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
